// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__W-rtx","select":"Header_select__2Zax8","clinic":"Header_clinic__qJfV2"};